// Mapping of variant IDs to their specific benefits
const variantBenefitsMap = {
  // Variants with updated benefits list (all except 44140962873398)
  '52682272637270': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Paquete muestra con todos nuestros sabores con tu 2do pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682535567702': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Paquete muestra con todos nuestros sabores con tu 2do pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682447356246': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Paquete muestra con todos nuestros sabores con tu 2do pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '52682432807254': [
    '10% de descuento en tus pedidos',
    'Envío gratis en cada pedido',
    'Paquete muestra con todos nuestros sabores con tu 2do pedido',
    'Cambia sabores cuando quieras',
    'Salta un mes cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de €43)'
  ],
  '44760214732854': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44760215027766': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44760227381302': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227414070': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227446838': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227479606': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227512374': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227545142': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  // Variant 44140962873398: updated list without "Swap flavors anytime" ($3.00)
  '44140962873398': [
    'Enjoy 10% off on every order ($3.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  // Variant 44239538356278: Creatine MX inventory (same benefits as 44140962873398, MXN amounts)
  '44239538356278': [
    'Enjoy 10% off on every order ($70)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44336518561846': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784753119286': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784753905718': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784755052598': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '44336496312374': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '43784754561078': [
    'Enjoy 10% off on every order ($4.00)',
    'Free shipping on every order ($4.99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  // Mexican pesos (MXN) variants – English copy with MXN amounts
  '44336530554934': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030751014966': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030753964086': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44336499032118': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44031252496438': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '44030750130230': [
    'Enjoy 10% off on every order ($80)',
    'Free shipping on every order ($99)',
    'Try all of our flavors for free (6-flavor sample pack included on your first order)',
    'Once you’ve tried them all, you can swap flavors for your monthly delivery anytime',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ],
  '47614259527734': [
    'Lock in this price on all your future orders',
    'Free shipping on every order ($4.99)',
    'Try all of our electrolytes flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($50 Value)'
  ],
  '47608293949494': [
    'Lock in this price on all your future orders',
    'Free shipping on every order ($99)',
    'Try all of our electrolytes flavors for free (6-flavor sample pack included on your first order)',
    'Skip every other month whenever you need',
    'Cancel anytime',
    'Become a part of the Tribe',
    'Exclusive Thermos on your 1-Year Anniversary ($999 Value)'
  ]
};

// Spanish benefits copy (used when #shop-language-locale value is "es")
const variantBenefitsMapEs = {
  '44683455889462': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44683455922230': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44683455954998': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760214601782': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760214732854': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760215027766': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44760227381302': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227414070': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227446838': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227479606': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227512374': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44760227545142': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],

  // 44140962873398: updated list without "Swap flavors" ($3.00)
  '44140962873398': [
    'Disfruta 10% de descuento en cada pedido ($3.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],

  // Variant 44239538356278: Creatine MX inventory (same benefits as 44140962873398, MXN amounts)
  '44239538356278': [
    'Disfruta 10% de descuento en cada pedido ($70)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44336518561846': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784753119286': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784753905718': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784755052598': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '44336496312374': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  '43784754561078': [
    'Disfruta 10% de descuento en cada pedido ($4.00)',
    'Envío gratis en cada pedido ($4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $50)'
  ],
  // Mexican pesos (MXN) variants
  '44336530554934': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030751014966': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030753964086': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44336499032118': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44031252496438': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '44030750130230': [
    'Disfruta 10% de descuento en cada pedido ($80)',
    'Envío gratis en cada pedido ($99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Cambia sabores cuando quieras',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor $999)'
  ],
  '47614259527734': [
    'Asegura este precio en todos tus futuros pedidos',
    'Envío gratis en cada pedido (valor de $4.99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de $50)'
  ],
  '47608293949494': [
    'Asegura este precio en todos tus futuros pedidos',
    'Envío gratis en cada pedido (valor de $99)',
    'Paquete de 6 sabores con tu 2.º pedido',
    'Salta cada dos meses cuando lo necesites',
    'Cancela cuando quieras',
    'Forma parte de la Tribu',
    'Termo exclusivo en tu aniversario de 1 año (valor de $999)'
  ]
};

// Mapping of variant IDs to delivery frequency (in days)
const variantDeliveryDaysMap = {
  '52682272637270': 30,
  '52682535567702': 30,
  '52682447356246': 30,
  '52682432807254': 30,
  '44760214732854': 30,
  '44760215027766': 30,
  '44760214732854': 30,
  '44760227381302': 30,
  '44760227414070': 30,
  '44760227446838': 30,
  '44760227479606': 30,
  '44760227512374': 30,
  '44760227545142': 30,
  '44140962873398': 60,  // New variant delivers every 60 days
  '44239538356278': 60,
  '44336518561846': 30,
  '43784753119286': 30,
  '43784753905718': 30,
  '43784755052598': 30,
  '44336496312374': 30,
  '43784754561078': 30,
  '44336530554934': 30,
  '44030751014966': 30,
  '44030753964086': 30,
  '44336499032118': 30,
  '44031252496438': 30,
  '44030750130230': 30,
  '47614259527734': 30,
  '47608293949494': 30
};

/** Creatine (US + MX inventory) — frequency selling plans shown in a select below benefits (must match cart). */
const CREATINE_PRODUCT_VARIANT_IDS = ['44140962873398', '44239538356278'];

function isCreatineProductVariantId(variantId) {
  return CREATINE_PRODUCT_VARIANT_IDS.indexOf(String(variantId)) !== -1;
}
/** Creatine `.group_list`: hide these 15% selling-plan rows (widget still lists them otherwise). */
const CREATINE_HIDE_15_PERCENT_SELLING_PLAN_IDS = ['1694138422', '2094661686'];
/** Creatine: prefer this row as the “Subscribe” primary after 15% rows are hidden (10% monthly). */
const CREATINE_PRIMARY_SUBSCRIBE_SELLING_PLAN_ID = '2094628918';
/** Order: 1‑month plan first, then 2‑month (IDs matched to Shopify selling plans). */
const CREATINE_FREQUENCY_SELLING_PLAN_IDS = ['2094628918', '1694105654'];
/** Dropdown labels only (plan id ↔ interval; do not infer from Shopify names). */
const CREATINE_FREQUENCY_LABELS_EN = {
  '2094628918': 'Every 30 days',
  '1694105654': 'Every 2 months'
};
const CREATINE_FREQUENCY_LABELS_ES = {
  '2094628918': 'Cada 30 días',
  '1694105654': 'Cada 2 meses'
};

function creatineFrequencyOptionLabel(planId, isSpanish) {
  const map = isSpanish ? CREATINE_FREQUENCY_LABELS_ES : CREATINE_FREQUENCY_LABELS_EN;
  return map[String(planId)] || null;
}

function creatineIsSubscribeSelected(section) {
  if (!section) return false;
  const oneTime = section.querySelector('.one_time_purchase_option_app_block input[type="radio"]');
  if (oneTime && oneTime.checked) return false;
  return !!section.querySelector('input[data-radio-type="selling_plan"][type="radio"]:checked');
}

function creatineGetProductFormScope(addToCartBtn) {
  let root = addToCartBtn.closest('product-form-component');
  if (root) return root;
  root = addToCartBtn.closest('form[action*="/cart/add"]');
  if (root) return root;
  return document.querySelector('product-form-component');
}

function hideCreatineFrequencyErrorPopover(select) {
  const wrap = select && select.closest('.subscription-creatine-frequency-wrap');
  const pop = wrap && wrap.querySelector('.subscription-creatine-frequency-error-popover');
  if (!pop) return;
  pop.style.display = 'none';
  if (hideCreatineFrequencyErrorPopover._timer) {
    clearTimeout(hideCreatineFrequencyErrorPopover._timer);
    hideCreatineFrequencyErrorPopover._timer = null;
  }
  if (hideCreatineFrequencyErrorPopover._outside) {
    document.removeEventListener('click', hideCreatineFrequencyErrorPopover._outside);
    hideCreatineFrequencyErrorPopover._outside = null;
  }
}

function positionCreatineFrequencyErrorPopover(wrap, pop) {
  const gapDesktop = 16;
  pop.style.left = '';
  pop.style.right = '';
  pop.style.top = '';
  pop.style.marginLeft = '';
  pop.style.marginTop = '';
  pop.style.transform = '';
  pop.style.alignSelf = '';
  pop.style.width = '';
  const arrow = wrap.querySelector('.subscription-creatine-frequency-error-popover-arrow');
  const isMobile =
    typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;
  if (arrow) {
    arrow.style.display = 'block';
    arrow.style.width = '0';
    arrow.style.height = '0';
    arrow.style.borderStyle = 'solid';
    arrow.style.pointerEvents = 'none';
    arrow.style.marginLeft = '';
    arrow.style.marginTop = '';
    if (isMobile) {
      arrow.style.left = '50%';
      arrow.style.right = 'auto';
      arrow.style.top = '-9px';
      arrow.style.transform = 'translateX(-50%)';
      arrow.style.borderWidth = '0 8px 9px 8px';
      arrow.style.borderColor = 'transparent transparent #000 transparent';
    } else {
      arrow.style.left = '-8px';
      arrow.style.right = 'auto';
      arrow.style.top = '50%';
      arrow.style.transform = 'translateY(-50%)';
      arrow.style.borderWidth = '7px 8px 7px 0';
      arrow.style.borderColor = 'transparent #000 transparent transparent';
    }
  }
  if (isMobile) {
    pop.style.left = 'auto';
    pop.style.right = 'auto';
    pop.style.alignSelf = 'center';
    pop.style.width = 'max-content';
    pop.style.maxWidth = 'min(280px, 72vw)';
    pop.style.top = '100%';
    pop.style.marginTop = '14px';
  } else {
    const selectEl = wrap.querySelector('.subscription-creatine-frequency-select');
    if (selectEl) {
      const wrapRect = wrap.getBoundingClientRect();
      const selRect = selectEl.getBoundingClientRect();
      pop.style.left = selRect.right - wrapRect.left + gapDesktop + 'px';
      pop.style.top = selRect.top - wrapRect.top + selRect.height / 2 + 'px';
      pop.style.transform = 'translateY(-50%)';
    } else {
      pop.style.left = '100%';
      pop.style.marginLeft = gapDesktop + 'px';
      pop.style.top = '0';
      pop.style.transform = '';
    }
  }
}

function showCreatineFrequencyErrorPopover(select) {
  const wrap = select.closest('.subscription-creatine-frequency-wrap');
  if (!wrap) return;
  const pop = wrap.querySelector('.subscription-creatine-frequency-error-popover');
  if (!pop) return;
  hideCreatineFrequencyErrorPopover(select);
  positionCreatineFrequencyErrorPopover(wrap, pop);
  pop.style.display = 'block';
  hideCreatineFrequencyErrorPopover._timer = setTimeout(function () {
    hideCreatineFrequencyErrorPopover(select);
  }, 6000);
  hideCreatineFrequencyErrorPopover._outside = function (ev) {
    if (wrap.contains(ev.target)) return;
    hideCreatineFrequencyErrorPopover(select);
  };
  setTimeout(function () {
    document.addEventListener('click', hideCreatineFrequencyErrorPopover._outside);
  }, 0);
}

function resetBuyButtonSubmitAfterCreatineBlock(btn) {
  if (!btn) return;
  function clear() {
    btn.removeAttribute('data-added');
    btn.removeAttribute('aria-busy');
  }
  clear();
  setTimeout(clear, 0);
  requestAnimationFrame(clear);
}

/** @returns {{ btn: HTMLButtonElement, selectEl: HTMLElement } | null} */
function resolveCreatineFrequencyAddToCartBlock(target) {
  if (!target || !target.closest) return null;
  const btn = target.closest('button');
  if (!btn) return null;
  const bid = btn.id || '';
  if (!bid.startsWith('BuyButtons-ProductSubmitButton-') || !bid.endsWith('__add-to-cart')) return null;

  const formScope = creatineGetProductFormScope(btn);
  const idInput = formScope && formScope.querySelector('input[name="id"]');
  const variantId = idInput && String(idInput.value);
  if (!variantId || !isCreatineProductVariantId(variantId)) return null;

  const selectEl = document.getElementById('subscription-creatine-frequency-select-' + variantId);
  if (!selectEl) return null;

  const section = document.querySelector('section[data-variant-id="' + variantId + '"]');
  if (!section || !creatineIsSubscribeSelected(section)) return null;

  if (selectEl.dataset.frequencyCommitted === 'true') return null;

  return { btn: btn, selectEl: selectEl };
}

function bindCreatineFrequencyAddToCartValidation() {
  if (bindCreatineFrequencyAddToCartValidation._bound) return;
  bindCreatineFrequencyAddToCartValidation._bound = true;

  function onPointerOrClick(e) {
    if (e.type === 'pointerdown' && typeof e.button === 'number' && e.button !== 0) return;
    const resolved = resolveCreatineFrequencyAddToCartBlock(e.target);
    if (!resolved) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    resetBuyButtonSubmitAfterCreatineBlock(resolved.btn);
    showCreatineFrequencyErrorPopover(resolved.selectEl);
    resetBuyButtonSubmitAfterCreatineBlock(resolved.btn);
  }

  document.addEventListener('pointerdown', onPointerOrClick, true);
  document.addEventListener('click', onPointerOrClick, true);

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || !form.getAttribute || form.tagName !== 'FORM') return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart/add') === -1 && action.indexOf('cart/add') === -1) return;
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput && String(idInput.value);
      if (!variantId || !isCreatineProductVariantId(variantId)) return;
      const selectEl = document.getElementById('subscription-creatine-frequency-select-' + variantId);
      if (!selectEl) return;
      const section = document.querySelector('section[data-variant-id="' + variantId + '"]');
      if (!section || !creatineIsSubscribeSelected(section)) return;
      if (selectEl.dataset.frequencyCommitted === 'true') return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const btn = form.querySelector(
        'button[id^="BuyButtons-ProductSubmitButton-"][id$="__add-to-cart"]'
      );
      resetBuyButtonSubmitAfterCreatineBlock(btn);
      showCreatineFrequencyErrorPopover(selectEl);
      resetBuyButtonSubmitAfterCreatineBlock(btn);
    },
    true
  );
}

/** Hide Creatine-only 15% options in the subscription app `group_list`; show 10% monthly row. */
function hideCreatineFifteenPercentPlanRowsInGroupList(groupList) {
  if (!groupList) return;
  CREATINE_HIDE_15_PERCENT_SELLING_PLAN_IDS.forEach(function (planId) {
    const inp = groupList.querySelector('input[data-selling-plan-id="' + planId + '"]');
    if (!inp) return;
    const row = inp.closest('li') || inp.closest('[role="listitem"]');
    if (row) {
      row.style.display = 'none';
    } else {
      inp.style.display = 'none';
    }
  });
  const tenMonthly = groupList.querySelector(
    'input[data-selling-plan-id="' + CREATINE_PRIMARY_SUBSCRIBE_SELLING_PLAN_ID + '"]'
  );
  if (tenMonthly) {
    const row = tenMonthly.closest('li') || tenMonthly.closest('[role="listitem"]');
    if (row) {
      row.style.removeProperty('display');
    }
  }
}

function snapshotSellingPlanRadioAttrs(el) {
  if (!el || !el.attributes) return {};
  const out = {};
  for (let i = 0; i < el.attributes.length; i++) {
    const a = el.attributes[i];
    const n = a.name;
    if (n === 'id' || n === 'checked' || n === 'class' || n === 'style') continue;
    if (n === 'name' || n === 'value' || n.indexOf('data-') === 0) {
      out[n] = a.value;
    }
  }
  return out;
}

function buildCreatineSellingPlanSnapshots(section, primaryRadio) {
  const snapshots = {};
  CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (planId) {
    const nodes = section.querySelectorAll('input[data-selling-plan-id="' + planId + '"]');
    let source = null;
    nodes.forEach(function (n) {
      if (n !== primaryRadio) source = n;
    });
    if (!source && nodes.length) source = nodes[0];
    if (source) snapshots[planId] = snapshotSellingPlanRadioAttrs(source);
  });
  return snapshots;
}

function hideCreatineFrequencyRowsExceptPrimary(section, primaryRadio) {
  CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (pid) {
    section.querySelectorAll('input[data-selling-plan-id="' + pid + '"]').forEach(function (inp) {
      if (inp === primaryRadio) return;
      const row = inp.closest('li') || inp.closest('[role="listitem"]');
      if (row) row.style.display = 'none';
      else inp.style.display = 'none';
    });
  });
}

function applyCreatinePlanToPrimaryRadio(section, primaryRadio, planId, snapshots) {
  const attrs = snapshots[planId];
  if (!primaryRadio || !attrs) return;
  Object.keys(attrs).forEach(function (k) {
    primaryRadio.setAttribute(k, attrs[k]);
  });
  CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (pid) {
    section.querySelectorAll('input[data-selling-plan-id="' + pid + '"]').forEach(function (inp) {
      if (inp !== primaryRadio) inp.checked = false;
    });
  });
  primaryRadio.checked = true;
  primaryRadio.dispatchEvent(new Event('input', { bubbles: true }));
  primaryRadio.dispatchEvent(new Event('change', { bubbles: true }));
}

function injectCreatineFrequencySelect(section, subscribeGroup, isSpanish, primaryRadio) {
  const variantId = section.getAttribute('data-variant-id');
  const selectId = 'subscription-creatine-frequency-select-' + variantId;
  const hasAnyPlanInput = CREATINE_FREQUENCY_SELLING_PLAN_IDS.some(function (pid) {
    return !!section.querySelector('input[data-selling-plan-id="' + pid + '"]');
  });
  if (!hasAnyPlanInput) {
    console.warn('Creatine frequency select: no selling plan inputs found for', CREATINE_FREQUENCY_SELLING_PLAN_IDS.join(', '));
    return;
  }

  const wrap = document.createElement('div');
  wrap.className = 'subscription-creatine-frequency-wrap';
  wrap.style.cssText =
    'margin-top: 12px; display: flex; flex-direction: column; gap: 6px; width: 100%; max-width: 100%; box-sizing: border-box; align-items: flex-start; position: relative;';

  const label = document.createElement('label');
  label.setAttribute('for', selectId);
  label.textContent = isSpanish ? 'Frecuencia de suscripción' : 'Subscription frequency';
  label.style.cssText = 'font-size: 0.9rem; font-weight: 600; font-family: inherit;';

  const select = document.createElement('select');
  select.id = selectId;
  select.className = 'subscription-creatine-frequency-select';
  select.setAttribute(
    'aria-label',
    isSpanish ? 'Frecuencia de entrega de la suscripción' : 'Subscription delivery frequency'
  );
  const creatineSelectChevron =
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="rgba(0,0,0,0.7)" d="M7 10l5 5 5-5z"/></svg>'
    );

  select.style.cssText =
    'box-sizing: border-box; width: min(100%, 360px); max-width: 100%; padding: 10px 40px 10px 20px; border-radius: 9999px; border: 1px solid rgba(0,0,0,0.25); font-size: 0.8rem; font-family: \'Nexa Black\', sans-serif; text-transform: uppercase; letter-spacing: 0.03em; cursor: pointer; color: #11121A; -webkit-appearance: none; -moz-appearance: none; appearance: none;';

  select.style.setProperty('background-color', 'transparent', 'important');
  select.style.setProperty('background-repeat', 'no-repeat', 'important');
  select.style.setProperty('background-position', 'right 16px center', 'important');
  select.style.setProperty('background-size', '18px 18px', 'important');
  select.style.setProperty('background-image', 'url("' + creatineSelectChevron + '")', 'important');

  const optionTypography =
    'font-family: \'Nexa Black\', sans-serif; text-transform: uppercase; color: #11121A;';

  const placeholderOpt = document.createElement('option');
  placeholderOpt.value = '';
  placeholderOpt.selected = true;
  placeholderOpt.textContent = isSpanish
    ? 'Elige la frecuencia de renovación'
    : 'Choose your renewal frequency';
  placeholderOpt.style.cssText = optionTypography;
  select.appendChild(placeholderOpt);

  CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (planId) {
    if (!section.querySelector('input[data-selling-plan-id="' + planId + '"]')) return;
    const opt = document.createElement('option');
    opt.value = planId;
    opt.textContent = creatineFrequencyOptionLabel(planId, isSpanish) || planId;
    opt.style.cssText = optionTypography;
    select.appendChild(opt);
  });

  if (select.options.length <= 1) return;

  select.dataset.frequencyCommitted = 'false';

  const errorPopover = document.createElement('div');
  errorPopover.className = 'subscription-creatine-frequency-error-popover';
  errorPopover.setAttribute('role', 'alert');
  errorPopover.setAttribute('aria-live', 'polite');
  errorPopover.style.cssText =
    'display: none; position: absolute; z-index: 100; max-width: min(280px, 72vw); padding: 10px 14px; background: #000; color: #fff; font-family: \'Nexa Black\', sans-serif; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; line-height: 1.35; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.28); pointer-events: auto; overflow: visible; text-align: center;';

  const errorArrow = document.createElement('span');
  errorArrow.className = 'subscription-creatine-frequency-error-popover-arrow';
  errorArrow.setAttribute('aria-hidden', 'true');
  errorArrow.style.cssText =
    'display: none; position: absolute; left: -8px; top: 50%; transform: translateY(-50%); width: 0; height: 0; border-style: solid; border-width: 7px 8px 7px 0; border-color: transparent #000 transparent transparent; pointer-events: none;';

  const errorTextSpan = document.createElement('span');
  errorTextSpan.className = 'subscription-creatine-frequency-error-popover-text';
  errorTextSpan.textContent = isSpanish
    ? 'ELIGE UNA FRECUENCIA DE RENOVACIÓN'
    : 'Please choose a renewal frequency';
  errorTextSpan.style.cssText = 'position: relative; z-index: 1;';

  errorPopover.appendChild(errorArrow);
  errorPopover.appendChild(errorTextSpan);

  /** Until the shopper picks from this select, keep the placeholder selected (radio still gets default plan via apply). */
  var creatineFrequencyUserChoseFromSelect = false;

  function firstSellingPlanOptionValue() {
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value) return select.options[i].value;
    }
    return '';
  }

  function syncSelectFromPrimaryRadio() {
    if (!creatineFrequencyUserChoseFromSelect) return;
    const id = primaryRadio && primaryRadio.getAttribute('data-selling-plan-id');
    if (id && select.querySelector('option[value="' + id + '"]')) {
      select.value = id;
    } else {
      const fallback = firstSellingPlanOptionValue();
      if (fallback) select.value = fallback;
    }
  }

  if (primaryRadio) {
    const snapshots = buildCreatineSellingPlanSnapshots(section, primaryRadio);
    hideCreatineFrequencyRowsExceptPrimary(section, primaryRadio);

    let initialPlan = null;
    CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (pid) {
      section.querySelectorAll('input[data-selling-plan-id="' + pid + '"]').forEach(function (n) {
        if (n.checked) initialPlan = pid;
      });
    });
    if (!initialPlan || !snapshots[initialPlan]) {
      initialPlan = CREATINE_FREQUENCY_SELLING_PLAN_IDS.find(function (pid) {
        return !!snapshots[pid];
      });
    }
    if (initialPlan) {
      applyCreatinePlanToPrimaryRadio(section, primaryRadio, initialPlan, snapshots);
    }
    select.value = '';

    select.addEventListener('change', function () {
      if (!select.value) return;
      creatineFrequencyUserChoseFromSelect = true;
      select.dataset.frequencyCommitted = 'true';
      hideCreatineFrequencyErrorPopover(select);
      placeholderOpt.disabled = true;
      applyCreatinePlanToPrimaryRadio(section, primaryRadio, select.value, snapshots);
      syncSelectFromPrimaryRadio();
    });

    section.addEventListener(
      'change',
      function (e) {
        const t = e.target;
        if (t === primaryRadio) {
          syncSelectFromPrimaryRadio();
          return;
        }
        if (!t || !t.getAttribute) return;
        if (
          CREATINE_FREQUENCY_SELLING_PLAN_IDS.indexOf(String(t.getAttribute('data-selling-plan-id'))) !== -1
        ) {
          syncSelectFromPrimaryRadio();
        }
      },
      true
    );
  } else {
    function syncSelectFromCheckedRadios() {
      if (!creatineFrequencyUserChoseFromSelect) return;
      let checkedId = null;
      CREATINE_FREQUENCY_SELLING_PLAN_IDS.forEach(function (pid) {
        const el = section.querySelector('input[data-selling-plan-id="' + pid + '"]:checked');
        if (el) checkedId = pid;
      });
      if (checkedId && select.querySelector('option[value="' + checkedId + '"]')) {
        select.value = checkedId;
      } else {
        const fallback = firstSellingPlanOptionValue();
        if (fallback) select.value = fallback;
      }
    }

    select.value = '';

    select.addEventListener('change', function () {
      if (!select.value) return;
      creatineFrequencyUserChoseFromSelect = true;
      select.dataset.frequencyCommitted = 'true';
      hideCreatineFrequencyErrorPopover(select);
      placeholderOpt.disabled = true;
      const pid = select.value;
      const inp = section.querySelector('input[data-selling-plan-id="' + pid + '"]');
      if (inp) inp.click();
    });

    section.addEventListener(
      'change',
      function (e) {
        const t = e.target;
        if (!t || !t.getAttribute) return;
        if (
          t.getAttribute('data-selling-plan-id') &&
          CREATINE_FREQUENCY_SELLING_PLAN_IDS.indexOf(String(t.getAttribute('data-selling-plan-id'))) !== -1
        ) {
          syncSelectFromCheckedRadios();
        }
      },
      true
    );
  }

  wrap.appendChild(label);
  wrap.appendChild(select);
  wrap.appendChild(errorPopover);
  subscribeGroup.appendChild(wrap);
}

function injectSubscriptionBenefits() {
    console.log('Executing injectSubscriptionBenefits...');

    const localeInput = document.getElementById('shop-language-locale');
    const locale = (localeInput && localeInput.value ? String(localeInput.value) : '').trim().toLowerCase();
    const isSpanish = locale === 'es';
    
    // Array with variant IDs
    const variantIds = [
      '52682272637270',
      '52682535567702',
      '52682447356246',
      '52682432807254',
      '44760214732854',
      '44760215027766',
      '44140962873398',
      '44239538356278',
      '44336518561846',
      '43784753119286',
      '43784753905718',
      '43784755052598',
      '44336496312374',
      '43784754561078',
      '44760227381302',
      '44760227414070',
      '44760227446838',
      '44760227479606',
      '44760227512374',
      '44760227545142',
      '44336530554934',
      '44030751014966',
      '44030753964086',
      '44336499032118',
      '44031252496438',
      '44030750130230',
      '47614259527734',
      '47608293949494'
    ];
    
    variantIds.forEach(variantId => {
      // Select the specific section by data-variant-id
      const section = document.querySelector(`section[data-variant-id="${variantId}"]`);
      console.log(`Section found for variant ${variantId}:`, section);
      
      if (section) {
        // Check if content was already injected to avoid duplicates
        if (section.querySelector('.benefits-injected')) {
          console.log(`Content already injected for variant ${variantId}, skipping...`);
          return;
        }
        
        // New app block structure: .plan_card > .subscription_group (one-time, then subscription)
        const planCard = section.querySelector('.plan_card');
        const subscriptionGroups = planCard ? planCard.querySelectorAll('.subscription_group') : [];
        // First group = one-time purchase, second = subscription (has .group_list and no .one_time_purchase_option_app_block)
        let oneTimeGroup = null;
        let subscribeGroup = null;
        const tenPercentPlanId = '1607434294';
        const fifteenPercentPlanId = '1662681142';
        subscriptionGroups.forEach(function (grp) {
          if (grp.querySelector('.one_time_purchase_option_app_block')) {
            oneTimeGroup = grp;
            return;
          }

          // Some stores render multiple selling plans inside the same `.subscription_group`.
          // In that case, hiding the entire group would also hide the 10% option and prevent us
          // from ever selecting a `subscribeGroup`. Instead, hide only the 15% option row/item.
          const fifteenInput = grp.querySelector('input[data-selling-plan-id="' + fifteenPercentPlanId + '"]');
          if (fifteenInput) {
            const fifteenRow = fifteenInput.closest('li') || fifteenInput.closest('[role="listitem"]');
            if (fifteenRow) {
              fifteenRow.style.display = 'none';
            } else {
              // Fallback: if we can't find a row wrapper, hide the input itself.
              fifteenInput.style.display = 'none';
            }
          }

          // Prefer the 10% plan group as the subscription container.
          if (!subscribeGroup && grp.querySelector('input[data-selling-plan-id="' + tenPercentPlanId + '"]')) {
            subscribeGroup = grp;
            return;
          }

          // Fallback: if there's only one subscription group and it has a list, use it.
          if (!subscribeGroup && grp.querySelector('.group_list')) {
            subscribeGroup = grp;
          }
        });
        console.log(`Subscription groups found for variant ${variantId}:`, { oneTime: !!oneTimeGroup, subscribe: !!subscribeGroup });

        if (subscribeGroup) {
          // Optional: reorder so subscription appears before one-time (match old behavior)
          if (oneTimeGroup && planCard && oneTimeGroup.nextElementSibling === subscribeGroup) {
            planCard.insertBefore(subscribeGroup, oneTimeGroup);
          }

          // Move subscription radio + price into SUSCRIPCIÓN row: [Radio] SUSCRIPCIÓN [Price] (like one-time row)
          const titlePriceWrapper = subscribeGroup.querySelector(':scope > .title_and_price_wrapper');
          const groupList = subscribeGroup.querySelector('.group_list');
          if (groupList && isCreatineProductVariantId(variantId)) {
            hideCreatineFifteenPercentPlanRowsInGroupList(groupList);
          }
          let subscriptionRadio = null;
          let subscriptionPriceEl = null;
          let radioLi = null;
          if (groupList) {
            let firstLi = null;
            if (isCreatineProductVariantId(variantId)) {
              const anchorInput = groupList.querySelector(
                'input[data-selling-plan-id="' + CREATINE_PRIMARY_SUBSCRIBE_SELLING_PLAN_ID + '"]'
              );
              firstLi = anchorInput ? anchorInput.closest('li') : null;
            }
            if (!firstLi) {
              firstLi = groupList.querySelector('li');
            }
            if (firstLi) {
              subscriptionRadio = firstLi.querySelector('input[type="radio"][data-radio-type="selling_plan"]');
              subscriptionPriceEl = firstLi.querySelector('.in_widget_price');
              radioLi = firstLi;
            }
          }
          /** Creatine: keep reference for frequency select → primary subscribe radio sync */
          const subscribePrimaryRadio = subscriptionRadio;
          if (subscriptionRadio && titlePriceWrapper) {
            if (radioLi) radioLi.remove();
            subscriptionRadio.style.marginRight = '8px';
            // Label with two flex parts: left = radio + "SUSCRIPCIÓN", right = price (space-between pushes price right)
            const label = document.createElement('label');
            label.className = titlePriceWrapper.className;
            if (subscriptionRadio.id) label.setAttribute('for', subscriptionRadio.id);
            const leftBlock = document.createElement('div');
            leftBlock.style.display = 'flex';
            leftBlock.style.alignItems = 'baseline';
            leftBlock.appendChild(subscriptionRadio);
            const groupNameSpan = titlePriceWrapper.querySelector('.group_name');
            if (groupNameSpan) leftBlock.appendChild(groupNameSpan);
            label.appendChild(leftBlock);
            if (subscriptionPriceEl) {
              subscriptionPriceEl.style.marginLeft = 'auto';
              label.appendChild(subscriptionPriceEl);
            }
            titlePriceWrapper.parentNode.replaceChild(label, titlePriceWrapper);
          }

          // Get benefits for this specific variant
          const benefits = (isSpanish ? variantBenefitsMapEs : variantBenefitsMap)[variantId] || [];

          if (benefits.length === 0) {
            console.warn(`No benefits defined for variant ${variantId}`);
            return;
          }

          // Create the benefits list
          const benefitsList = document.createElement('ul');
          benefitsList.style.cssText = 'margin-top: 10px; padding-left: 20px; list-style-type: disc;';
          benefitsList.classList.add('benefits-injected');

          benefits.forEach(function (benefit) {
            const li = document.createElement('li');
            li.textContent = benefit;
            li.style.cssText = 'list-style-type: disc; display: list-item;';
            benefitsList.appendChild(li);
          });

          subscribeGroup.appendChild(benefitsList);

          if (isCreatineProductVariantId(variantId)) {
            injectCreatineFrequencySelect(section, subscribeGroup, isSpanish, subscribePrimaryRadio);
          } else {
            // Delivery frequency text: below the benefits list
            const deliveryDays = variantDeliveryDaysMap[variantId] || 30;
            const deliveryText = document.createElement('p');
            deliveryText.textContent = isSpanish
              ? 'Entrega cada ' + deliveryDays + ' días'
              : 'Deliver every ' + deliveryDays + ' days';
            deliveryText.style.cssText =
              'margin: 10px 0 0 0; font-family: \'Nexa Black\', sans-serif !important; text-transform: uppercase;';
            subscribeGroup.appendChild(deliveryText);
          }

          console.log('Content successfully injected for variant ' + variantId);
        }
      } else {
        console.log(`Section with data-variant-id="${variantId}" not found`);
      }
    });
  }
  
  // Execute on page load 
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded');
    injectSubscriptionBenefits();
  });
  
  // Also try with window.load in case content loads after
  window.addEventListener('load', function() {
    console.log('Window loaded');
    setTimeout(injectSubscriptionBenefits, 500);
  });

  bindCreatineFrequencyAddToCartValidation();